/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    ManagedAgentRegistrationDto,
    OnBoardingRequestDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class BlockchainIngressControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        approveCustomerOnBoarding(
                    customerId: number,
                    ethAddress: string
    ): Observable<any> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/customers/${customerId}/agents/${ethAddress}/roles/approve`;

            return this._httpClient.post(url, requestBody, requestOptions);
    }


        approveOrganizationOnBoarding(
                    organizationId: number,
                    ethAddress: string
    ): Observable<any> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/organizations/${organizationId}/agents/${ethAddress}/roles/approve`;

            return this._httpClient.post(url, requestBody, requestOptions);
    }


        approveWineryOnBoarding(
                    organizationId: number,
                    wineryId: number,
                    ethAddress: string
    ): Observable<any> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/organizations/${organizationId}/wineries/${wineryId}/agents/${ethAddress}/roles/approve`;

            return this._httpClient.post(url, requestBody, requestOptions);
    }


        createCustomerOnBoardingRequest(
                    customerId: number,
                    ethAddress: string
                    , 
                    
                    requestBody: OnBoardingRequestDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/customers/${customerId}/agents/${ethAddress}/roles`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        createOrganizationOnBoardingRequest(
                    organizationId: number,
                    ethAddress: string
                    , 
                    
                    requestBody: OnBoardingRequestDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/organizations/${organizationId}/agents/${ethAddress}/roles`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        createWineryOnBoardingRequest(
                    organizationId: number,
                    wineryId: number,
                    ethAddress: string
                    , 
                    
                    requestBody: OnBoardingRequestDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/organizations/${organizationId}/wineries/${wineryId}/agents/${ethAddress}/roles`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        getCustomerOnBoardingRequests(
                    customerId: number,
                    ethAddress: string
    ): Observable<OnBoardingRequestDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/customers/${customerId}/agents/${ethAddress}/roles`;

            return this._httpClient.get<OnBoardingRequestDto>(url, requestOptions);
    }


        getOrganizationOnBoardingRequests(
                    organizationId: number,
                    ethAddress: string
    ): Observable<OnBoardingRequestDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/organizations/${organizationId}/agents/${ethAddress}/roles`;

            return this._httpClient.get<OnBoardingRequestDto>(url, requestOptions);
    }


        getWineryOnBoardingRequests(
                    organizationId: number,
                    wineryId: number,
                    ethAddress: string
    ): Observable<OnBoardingRequestDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/organizations/${organizationId}/wineries/${wineryId}/agents/${ethAddress}/roles`;

            return this._httpClient.get<OnBoardingRequestDto>(url, requestOptions);
    }


        registerCustomerManagedAgent(
                    customerId: number
                    , 
                    
                    requestBody: ManagedAgentRegistrationDto
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/customers/${customerId}/agents`;

            return this._httpClient.post<string>(url, requestBody, requestOptions);
    }


        registerCustomerWalletlessAgent(
                    customerId: number
                    , 
                    
                    requestBody: string
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/customers/${customerId}/agents`;

            return this._httpClient.put<string>(url, requestBody, requestOptions);
    }


        registerOrganizationManagedAgent(
                    organizationId: number
                    , 
                    
                    requestBody: ManagedAgentRegistrationDto
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/organizations/${organizationId}/agents`;

            return this._httpClient.post<string>(url, requestBody, requestOptions);
    }


        registerOrganizationWalletlessAgent(
                    organizationId: number
                    , 
                    
                    requestBody: string
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/organizations/${organizationId}/agents`;

            return this._httpClient.put<string>(url, requestBody, requestOptions);
    }


        registerWineryManagedAgent(
                    wineryId: number,
                    organizationId: number
                    , 
                    
                    requestBody: ManagedAgentRegistrationDto
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/organizations/${organizationId}/wineries/${wineryId}/agents`;

            return this._httpClient.post<string>(url, requestBody, requestOptions);
    }


        registerWineryWalletlessAgent(
                    organizationId: number,
                    wineryId: number
                    , 
                    
                    requestBody: string
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/organizations/${organizationId}/wineries/${wineryId}/agents`;

            return this._httpClient.put<string>(url, requestBody, requestOptions);
    }


        searchEthAddresses(
                
                queryParams: {
                    customerId?: number,
                    legalEntityId?: number
                }
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/onboarding/ethaddresses`;

            return this._httpClient.get<string>(url, requestOptions);
    }


}

